<div class="progress-indicator-circle">
  <svg
    [attr.height]="size"
    [attr.width]="size">
    <circle
      class="progress-indicator-circle-base"
      [attr.cx]="circlePosition"
      [attr.cy]="circlePosition"
      [attr.r]="circleRadius"
      [attr.stroke-width]="stroke" />
    <circle
      class="progress-indicator-circle-lead"
      [attr.cx]="circlePosition"
      [attr.cy]="circlePosition"
      [attr.r]="circleRadius"
      [attr.stroke-width]="stroke"
      [ngStyle]="leadDynamicStyle" />
  </svg>
</div>
